import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { AppConfigurationDto, CabinetShelfRefDto, FiscalFileLocationDto, LandParcelDto, LandTitleDto, MeasureDto, MeasuringFactorDto, PurposeDto, RackTrayRefDto, StorageLocationDto } from '@cradua/data';
import Swal from 'sweetalert2';
import { StorageLocationTableComponent } from './storage-location-table/storage-location-table.component';

@Component({
  selector: 'cradua-storage-location',
  templateUrl: './storage-location.component.html',
  styleUrls: ['./storage-location.component.scss']
})
export class StorageLocationComponent implements OnInit {

  @Input() activitySelectedValue: string;
  @Input() selectedLandTitle: LandTitleDto;
  @Input() cabinetShelfRefs: CabinetShelfRefDto[];
  @Input() rackTrayRefs: RackTrayRefDto[];
  @Input() fileLocations: FiscalFileLocationDto[];
  @Output() emitSave = new EventEmitter<StorageLocationDto[]>();
  @ViewChild(StorageLocationTableComponent) child: StorageLocationTableComponent;

  storageLocationForm: FormGroup;
  selectedIndex = null;
  filterCabinetRefs: CabinetShelfRefDto[];
  filterRacks: RackTrayRefDto[];
  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.createStorageLocation();
  }

  createStorageLocation() {
    this.storageLocationForm = this.fb.group({
      FileLocationId: [''],
      CabinetShelfRefId: [''],
      RackTrayRefId: [''],
      FiscalFileRemarks: [''],
      IdentityRefId: [this.selectedLandTitle.id]
    });

  }

   protected filterById = <T>(id: string, lookupId: string) =>
   (fieldName: T) => fieldName[lookupId] === id;

   onEdit(value: StorageLocationDto) {
    this.selectedIndex = value['index'];
    this.onCabinetRef(value.FileLocationId);
    this.onFilterRack(value.CabinetShelfRefId);
    this.storageLocationForm.patchValue(value);
  }

  onCabinetRef(id: string) {
    this.filterCabinetRefs = this.cabinetShelfRefs.filter(
      this.filterById<CabinetShelfRefDto>(id, "FileLocationId"),
    );
  }

  onFilterRack(id: string) {
    this.filterRacks = this.rackTrayRefs.filter(
      this.filterById<RackTrayRefDto>(id, "CabinetShelfRefId"),
    );
  }


   addNew(formValue: StorageLocationDto) {
    if(this.storageLocationForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.child.storageLocationFormArray['controls'][this.selectedIndex].patchValue(formValue);
    } else {
      this.child.addStorageLocation(formValue);
    }
    this.selectedIndex = null;
    this.storageLocationForm.reset()
  }

   onSubmit(){
    this.emitSave.emit(this.child.storageLocationArrayForm.value['StorageLocations']);
  }

  onReset() {
    this.storageLocationForm.reset();
    this.selectedIndex = null;
  }



}
